import React, { useEffect, useState } from "react";
import styled, { withTheme } from "styled-components";
import { loginRegex, FieldsValidation } from "../../../modules/constants";
import { EmailInput } from "../../ui-library/AuthControls/EmailInput";
import { PasswordInput } from "../../ui-library/AuthControls/PasswordInput";
import { Button } from "../../ui-library/AuthControls/Button";
import AlertUGNX from "../../ToastsAndAlerts/AlertUGNX";
import { AlertType } from "../../ToastsAndAlerts/constants";
import { useTranslation } from "react-i18next";

const StyledError = styled.div`
  font-weight: 600;
  font-size: 12px;
  color: ${(props) => props.theme?.cardinal};
  text-transform: uppercase;
  margin-bottom: 1rem;
`;

const LinkButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  text-transform: uppercase;
  display: inline;
  margin: 0;
  padding: 0 0 10px 0;
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme?.violetEggplant};
  text-align: start;
  :hover {
    text-decoration: underline;
  }
`;

const Login = (props) => {
  const { onSubmit, errorMessage, onForgotPassword, buttonDisabled } = props;

  const { t } = useTranslation();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [validUsername, setValidUsername] = useState(false);

  const onLoginSubmit = (e) => {
    e.preventDefault();

    onSubmit(username, password);
  };

  useEffect(() => {
    if (
      (username && !loginRegex.test(username)) ||
      username?.length >= FieldsValidation.email.size ||
      !username
    ) {
      setValidUsername(false);
    } else {
      setValidUsername(true);
    }
  }, [username]);

  const onUsernameChange = (e) => {
    setUsername(e.target.value);
  };

  const onPasswordChange = (e) => {
    setPassword(e.target.value);
  };

  return (
    <form
      onSubmit={onLoginSubmit}
      className="auth-form"
      data-testid="login-view"
    >
      <EmailInput
        data-testid="username-input"
        onChange={onUsernameChange}
        value={username}
        loginInput={t("appText.auth.orParticipantID")}
        inputError={username && !validUsername}
      />
      <StyledError>
        {username && !validUsername && (
          <span>{t("errorText.auth.login.invalid.emailOrParticipantID")}</span>
        )}
      </StyledError>
      <PasswordInput
        placeholder={t("appText.auth.password")}
        onChange={onPasswordChange}
        value={password}
        margin="mb-3"
      />
      {errorMessage && (
        <AlertUGNX type={AlertType.DANGER}>
          <div dangerouslySetInnerHTML={{ __html: errorMessage }}></div>
        </AlertUGNX>
      )}
      <LinkButton type="button" onClick={onForgotPassword}>
        {`${t("appText.auth.forgotPassword").toLocaleUpperCase()}?`}
      </LinkButton>
      <Button text={t("appText.auth.login")} buttonDisabled={buttonDisabled} />
    </form>
  );
};

export default withTheme(Login);
